export default class CardsFilter {
    constructor() {
        const filter = document.querySelector('[data-pronouns-filter]');

        if(!filter) {
            return;
        }

        const checkboxes = document.querySelectorAll('[data-pronouns-checkbox]');

        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', () => {
                this.filterItems();
            });
        });
    }

    filterItems() {
        const checkedValues = Array.from(document.querySelectorAll('[data-pronouns-checkbox]:checked'))
            .map(cb => cb.value.split(' '))
            .flat();
        const cards = document.querySelectorAll('[data-pronouns]');



        // Show all cards if no checkbox is selected
        if (checkedValues.length === 0) {
            cards.forEach(card => {
                card.style.display = 'block';
            });

            document.dispatchEvent(new CustomEvent('update-scroll'));

            return;
        }

        cards.forEach(card => {
            const cardValues = card.getAttribute('data-pronouns').split(' ');
            const shouldDisplay = checkedValues.some(value => cardValues.includes(value));
            card.style.display = shouldDisplay ? 'block' : 'none';
        });

        document.dispatchEvent(new CustomEvent('update-scroll'));
    }
}